import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup, Modal, Table } from 'react-bootstrap'
import { ClientService } from '../services/client.service';
import TablePaginationComponent from '../table/TablePagination';
import moment from 'moment';
import { CSVLink } from 'react-csv';

interface IReverificationUsersModal {
    show: any,
    handleClose: any
}

export default function ReverificationUsersModal(props: IReverificationUsersModal) {
    const [key, setKey] = useState<'present' | 'absent'>('present');
    const [loading, setLoading] = useState<boolean>(false);
    const [reverificationUsers, setReverificationsUsers] = useState<any[]>([]);
    const [csvData, setCsvData] = useState<any[]>([]);

    const getAllUsersReverifications = async () => {
        setLoading(true);
        await ClientService.getReverificationStudentsData(key, props.show)
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data?.students || [];
                    setReverificationsUsers(data);
                    setCsvData(
                        data.map((item: any, index: number) => {
                            if (key === "present") {
                                return {
                                    "Sr. No": index + 1,
                                    "CET Roll No": item?.studentId?.reVerification_meta?.["CET Application No"] || "--",
                                    "CET Application No": item?.studentId?.reVerification_meta?.["CAP Application ID"] || "--",
                                    "Candidate Name": item?.studentId?.name || "--",
                                    "Institute Code": item?.studentId?.reVerification_meta?.["Alloted Institute Code"] || "--",
                                    "Institute Name": item?.studentId?.reVerification_meta?.["Alloted Institute Name"] || "--",
                                    "Stream": item?.studentId?.reVerification_meta?.["Stream"] || "--",
                                    "Verification Status": item?.success ? "Success" : "Not-Success",
                                    "Verification Time": item?.updatedAt ? moment(item?.updatedAt).format("DD-MM-YY, hh:mm A") : "--",
                                };
                            } else {
                                return {
                                    "Sr. No": index + 1,
                                    "CET Roll No": item?.reVerification_meta?.["CET Application No"] || "--",
                                    "CET Application No": item?.reVerification_meta?.["CAP Application ID"] || "--",
                                    "Candidate Name": item?.name || "--",
                                    "Institute Code": item?.reVerification_meta?.["Alloted Institute Code"] || "--",
                                    "Institute Name": item?.reVerification_meta?.["Alloted Institute Name"] || "--",
                                    "Stream": item?.reVerification_meta?.["Stream"] || "--",
                                    "Verification Status": item?.success ? "Success" : "Not-Success",
                                    "Verification Time": item?.updatedAt ? moment(item?.updatedAt).format("DD-MM-YY, hh:mm A") : "--",
                                };
                            }
                        })
                    );

                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (props.show && key) {
            getAllUsersReverifications();
        }
    }, [props.show, key]);

    return (
        <Modal
            show={props.show ? true : false}
            onHide={props.handleClose}
            size="xl"
            animation={true}
            backdrop="static"
            centered
        >
            <Modal.Header closeButton />
            <div className='p-2'>

                {/* Segmented Tabs + CSV Download */}
                <div className='d-flex justify-content-between align-items-center mb-3'>
                    <ButtonGroup>
                        <Button
                            variant={key === 'present' ? 'primary' : 'outline-primary'}
                            onClick={() => setKey('present')}
                        >
                            Verified
                        </Button>
                        <Button
                            variant={key === 'absent' ? 'primary' : 'outline-primary'}
                            onClick={() => setKey('absent')}
                        >
                            Not Verified
                        </Button>
                    </ButtonGroup>

                    {csvData.length > 0 && (
                        <CSVLink
                            data={csvData}
                            filename={`Reverifications_${key}.csv`}
                            className="btn btn-primary"
                        >
                            {loading ? "Preparing..." : `Download ${key === "present" ? "Verified" : "Not Verified"} CSV`}
                        </CSVLink>
                    )}
                </div>

                {/* Tab Content */}
                {key === 'present' && (
                    <>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th style={{ fontSize: 14 }}>S.No</th>
                                    <th style={{ fontSize: 14 }}>CET Roll No</th>
                                    <th style={{ fontSize: 14 }}>CET Application No</th>
                                    <th style={{ fontSize: 14 }}>Candidate Name</th>
                                    <th style={{ fontSize: 14 }}>Institute Code</th>
                                    <th style={{ fontSize: 14 }}>Institute Name </th>
                                    <th style={{ fontSize: 14 }}>Stream</th>
                                    <th style={{ fontSize: 14 }}>V. Status</th>
                                    <th style={{ fontSize: 14 }}>V. Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reverificationUsers.length > 0 ? (
                                    reverificationUsers.map((item: any, index: number) => (
                                        <tr key={item?._id}>
                                            <td style={{ fontSize: 12 }}>{index + 1}</td>
                                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["CET Application No"]}</td>
                                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["CAP Application ID"]}</td>
                                            <td style={{ fontSize: 12 }}>{item?.studentId?.name}</td>
                                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["Alloted Institute Code"]}</td>
                                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["Alloted Institute Name"]}</td>
                                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.Stream}</td>
                                            <td style={{ fontSize: 12 }}>
                                                {item?.success
                                                    ? <span className='text-success'>Success</span>
                                                    : <span className='text-warning'>Not-Success</span>}
                                            </td>
                                            <td style={{ fontSize: 12 }}>{item?.updatedAt ? moment(item?.updatedAt).format("DD-MM-YY, hh:mm A") : "--"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={12} className="text-center">
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </>
                )}

                {key === 'absent' && (
                    <Table striped hover responsive>
                        <thead>
                            <tr>
                                <th style={{ fontSize: 14 }}>S.No</th>
                                <th style={{ fontSize: 14 }}>CET Roll No</th>
                                <th style={{ fontSize: 14 }}>CET Application No</th>
                                <th style={{ fontSize: 14 }}>Candidate Name</th>
                                <th style={{ fontSize: 14 }}>Institute Code</th>
                                <th style={{ fontSize: 14 }}>Institute Name </th>
                                <th style={{ fontSize: 14 }}>Stream</th>
                                <th style={{ fontSize: 14 }}>V. Status</th>
                                <th style={{ fontSize: 14 }}>V. Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reverificationUsers.length > 0 ? (
                                reverificationUsers.map((item: any, index: number) => (
                                    <tr key={item?._id}>
                                        <td style={{ fontSize: 12 }}>{index + 1}</td>
                                        <td style={{ fontSize: 12 }}>{item?.reVerification_meta?.["CET Application No"]}</td>
                                        <td style={{ fontSize: 12 }}>{item?.reVerification_meta?.["CAP Application ID"]}</td>
                                        <td style={{ fontSize: 12 }}>{item?.name}</td>
                                        <td style={{ fontSize: 12 }}>{item?.reVerification_meta?.["Alloted Institute Code"]}</td>
                                        <td style={{ fontSize: 12 }}>{item?.reVerification_meta?.["Alloted Institute Name"]}</td>
                                        <td style={{ fontSize: 12 }}>{item?.reVerification_meta?.Stream}</td>
                                        <td style={{ fontSize: 12 }}>
                                            {item?.success
                                                ? <span className='text-success'>Success</span>
                                                : <span className='text-warning'>Not-Success</span>}
                                        </td>
                                        <td style={{ fontSize: 12 }}>{item?.updatedAt ? moment(item?.updatedAt).format("DD-MM-YY, hh:mm A") : "--"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={12} className="text-center">
                                        No Data Available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                )}
            </div>

            <Modal.Body />
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
